// custom mapbopx-gl-draw mode that extends draw_line_string
// shows a center point, radius line, and circle polygon while drawing
// forces draw.create on creation of second vertex
const circle = require('@turf/circle').default;
const length = require('@turf/length').default;
const MapboxDraw = require('@mapbox/mapbox-gl-draw');

const { getDisplayMeasurements } = require('./util.js');

function circleFromTwoVertexLineString(geojson) {
    const center = geojson.geometry.coordinates[0];
    const radiusInKm = length(geojson);

    return circle(center, radiusInKm);
}

export default {
    ...MapboxDraw.modes.draw_line_string,

    onSetup: function(opts) {
        opts = opts || {};
        var featureId = opts.featureId;

        var line, currentVertexPosition;
        var direction = 'forward';
        if (featureId) {
            line = this.getFeature(featureId);
            if (!line) {
                throw new Error('Could not find a feature with the provided featureId');
            }
            var from = opts.from;
            if (
                from &&
                from.type === 'Feature' &&
                from.geometry &&
                from.geometry.type === 'Point'
            ) {
                from = from.geometry;
            }
            if (
                from &&
                from.type === 'Point' &&
                from.coordinates &&
                from.coordinates.length === 2
            ) {
                from = from.coordinates;
            }
            if (!from || !Array.isArray(from)) {
                throw new Error(
                    'Please use the `from` property to indicate which point to continue the line from',
                );
            }
            var lastCoord = line.coordinates.length - 1;
            if (
                line.coordinates[lastCoord][0] === from[0] &&
                line.coordinates[lastCoord][1] === from[1]
            ) {
                currentVertexPosition = lastCoord + 1;
                // add one new coordinate to continue from
                line.addCoordinate.apply(
                    line,
                    [currentVertexPosition].concat(line.coordinates[lastCoord]),
                );
            } else if (line.coordinates[0][0] === from[0] && line.coordinates[0][1] === from[1]) {
                direction = 'backwards';
                currentVertexPosition = 0;
                // add one new coordinate to continue from
                line.addCoordinate.apply(line, [currentVertexPosition].concat(line.coordinates[0]));
            } else {
                throw new Error(
                    '`from` should match the point at either the start or the end of the provided LineString',
                );
            }
        } else {
            line = this.newFeature({
                type: 'Feature',
                properties: {},
                geometry: {
                    type: 'LineString',
                    coordinates: [],
                },
            });
            currentVertexPosition = 0;
            this.addFeature(line);
        }

        this.clearSelectedFeatures();
        // doubleClickZoom.disable(this);
        // this.updateUIClasses({ mouse: cursors.ADD });
        // this.activateUIButton(types$1.LINE);
        this.setActionableState({
            trash: true,
        });

        let circle = this.newFeature({
            type: 'Feature',
            properties: {},
            geometry: {
                type: 'Polygon',
                coordinates: [],
            },
        });

        this.addFeature(circle);

        return {
            line: line,
            circle: circle,
            currentVertexPosition: currentVertexPosition,
            direction: direction,
        };
    },

    clickAnywhere: function(state, e) {
        // this ends the drawing after the user creates a second point, triggering this.onStop
        if (state.currentVertexPosition === 1) {
            state.line.addCoordinate(0, e.lngLat.lng, e.lngLat.lat);
            return this.changeMode('simple_select', { featureIds: [state.line.id] });
        }

        state.line.updateCoordinate(state.currentVertexPosition, e.lngLat.lng, e.lngLat.lat);
        if (state.direction === 'forward') {
            state.currentVertexPosition += 1;
            state.line.updateCoordinate(state.currentVertexPosition, e.lngLat.lng, e.lngLat.lat);
        } else {
            state.line.addCoordinate(0, e.lngLat.lng, e.lngLat.lat);
        }

        return null;
    },

    onStop: function(state) {
        this.activateUIButton();

        // check to see if we've deleted this feature
        if (this.getFeature(state.line.id) === undefined) return;

        // remove last added coordinate
        state.line.removeCoordinate('0');
        if (state.line.isValid()) {
            const lineGeoJson = state.line.toGeoJSON();
            let circleFeature = circleFromTwoVertexLineString(lineGeoJson);
            circleFeature['properties']['shape'] = 'circle';

            console.warn('Circle line!', lineGeoJson);
            circleFeature['properties']['center'] = lineGeoJson['geometry']['coordinates'][0];
            circleFeature['properties']['radius'] = length(lineGeoJson);

            console.log('Before create', state.circle);

            state.circle.setCoordinates(circleFeature['geometry']['coordinates']);

            this.map.fire('draw.create', {
                features: [circleFeature],
            });

            this.deleteFeature([state.line.id], { silent: true });
        } else {
            this.deleteFeature([state.line.id], { silent: true });
            this.changeMode('simple_select', {}, { silent: true });
        }
    },

    toDisplayFeatures: function(state, geojson, display) {
        // Only render the line if it has at least one real coordinate
        if (geojson.geometry.coordinates.length < 2) return null;

        display({
            type: 'Feature',
            properties: {
                active: 'true',
            },
            geometry: {
                type: 'Point',
                coordinates: geojson.geometry.coordinates[0],
            },
        });

        // displays the line as it is drawn
        geojson.properties.active = 'true';
        display(geojson);

        const displayMeasurements = getDisplayMeasurements(geojson);

        // create custom feature for the current pointer position
        const currentVertex = {
            type: 'Feature',
            properties: {
                meta: 'currentPosition',
                radius: `${displayMeasurements.metric} ${displayMeasurements.standard}`,
                parent: state.line.id,
            },
            geometry: {
                type: 'Point',
                coordinates: geojson.geometry.coordinates[1],
            },
        };

        display(currentVertex);

        const circleFeature = circleFromTwoVertexLineString(geojson);

        circleFeature.properties = {
            active: 'true',
        };

        display(circleFeature);

        return null;
    },
};
